import { createSlice } from '@reduxjs/toolkit';
import GetPaginationQueryString from '../../utils/pageExtensions';
import Config from '../../config.js';
import GetHttpResponseError from '../../utils/httpExtensions';

export const personSlice = createSlice({
    name: 'person',
    initialState: {
        persons: []
    },
    reducers: {
        fetchPerson: (state, action) => {
            fetch(Config.FHIRAPIUrl + 'Person/' + action.payload.id)
                .then((response) => response.json())
                .then((response) => {
                    if (action.payload.callback)
                        action.payload.callback(response);
                })
                .catch((error) => {
                    if (action.payload.catch)
                        action.payload.catch(error);
                });
        },
        fetchPersons: (state, action) => {
            let paginationQuery = GetPaginationQueryString(action.payload.pagination);

            let url = Config.FHIRAPIUrl + 'Person?' + paginationQuery
                + '&active=' + action.payload.filter.active
                + '&gender=' + action.payload.filter.gender
                + '&managingOrganization=' + action.payload.filter.managingOrganization
                + '&birthDate=' + action.payload.filter.birthDate;

            fetch(url, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${action.payload.token}`
                }
            })
                .then((response) => {
                    GetHttpResponseError(response);

                    if (!response.ok) {
                        const errorMessage = response.statusText;
                        throw new Error(errorMessage ? errorMessage : 'Failed to fetch persons');
                    }
                    return response.json()
                })
                .then((response) => {
                    if (action.payload.callback)
                        action.payload.callback(response);
                })
                .catch((error) => {
                    if (action.payload.catch)
                        action.payload.catch(error);
                });
        },
        setPersons: (state, action) => {
            state.persons = action.payload || [];
        }
    }
})

export const { setPersons, fetchPerson, fetchPersons } = personSlice.actions

export default personSlice.reducer